/**
 * @module
 * Entities are game elements or "virtual" containers.
 * Entities are made up of Traits.
 *
 * `@cardsgame/server` contains many basic entities and containers, but you can create your own.
 *
 * ::tip Remember
 *
 * This page explains entities on server-side.
 * It's up to you to define how these entities look like on the client-side.
 *
 * :::
 */

export * from "./classicCard.js"
export * from "./container.js"
export * from "./deck.js"
export * from "./grid.js"
export * from "./hand.js"
export * from "./line.js"
export * from "./pile.js"
export * from "./spread.js"
export * from "./selection.js"
